import styled from "styled-components"
import fontValues from "../../../assets/values/fontValues/fontValues.json"

export const Name = styled.p `

    margin: 0;
    text-align: end;
    font-family: ${fontValues.TEXT_FONT_FAMILY};
    font-size: ${fontValues.MEDIUM_TEXT_SIZE};
    color: ${({theme}) => theme.colors.DARK_TEXT};

`